import { Component, EventEmitter, Input, Output, ViewChild, inject } from '@angular/core';
import { FmDatePickerComponent } from '../../../fannie-mae-cdx-components/fm-date-picker/fm-date-picker.component';
import { EnterBalancesValidationServiceService } from '../../services/enter-balances-validation-service.service';
import { DateSelectedService } from '../date-selected.service';

@Component({
  standalone: false,
  selector: 'invd-sticky-input-toolbar',
  templateUrl: './sticky-input-toolbar.component.html',
  styleUrls: ['./sticky-input-toolbar.component.scss'],
})
export class StickyInputToolbarComponent {
  @Input() buttonText: string;
  @Input() showCalendar: boolean;
  @Input() showClearAllButton: boolean;
  @Input() showCancelButton: boolean;
  @Input() labelText: string;
  @Input() clearAllButtonText: string;
  @Input() cancelText: string;
  @Output() selectedDateChange: number;
  @Output() buttonClicked = new EventEmitter<boolean>();
  @Output() clearButtonClicked = new EventEmitter<boolean>();

  @ViewChild(FmDatePickerComponent, { static: true })
  public fmDatePickerComponent: FmDatePickerComponent;

  @Input() mDateValue = 'mm/dd/yyyy';

  @Output() cancelClicked = new EventEmitter<boolean>();
  public showFooter = false;

  private selectedDateService = inject(DateSelectedService);
  private enterBalancesValidationService = inject(EnterBalancesValidationServiceService);

  protected setDate(val) {
    this.fmDatePickerComponent.initDateValue(val);
  }

  protected setAsOfDate(selectedDate: Date): void {
    const date = new Date(selectedDate);
    this.selectedDateChange = date.getTime();

    this.selectedDateService.broadcastDateSelected(selectedDate);
  }

  protected onButtonClicked(clicked: boolean): void {
    this.buttonClicked.emit(clicked);
  }

  protected cancelButtonClicked(): void {
    this.cancelClicked.emit(true);
  }

  protected onClearButtonClicked(clicked: boolean): void {
    this.clearButtonClicked.emit(clicked);
  }

  protected isFormValid(): boolean {
    return this.enterBalancesValidationService.isValid();
  }
}
